import { runRemoteCommand } from "./Util.ts";

import { ViewPushChannelListener } from "./PushChannelListener.ts";

export class UserProfile extends ViewPushChannelListener {
  constructor() {
    super();
    this.on("userProfileIdentityAdded", async (data) => this._handleUserProfileIdentityAdded(data));
  }

  private async _handleUserProfileIdentityAdded(_data: unknown): Promise<void> {
    await runRemoteCommand(BackendCommand?.updateProfileIdentities);
  }

  static createInstance(): UserProfile {
    return new UserProfile();
  }
}

export class UserSignup extends ViewPushChannelListener {
  constructor() {
    super("UserSignupChannelListener");
  }

  static createInstance(): UserSignup {
    return new UserSignup();
  }
}

export class UserInvite extends ViewPushChannelListener {
  constructor() {
    super("UserInviteChannelListener");
  }

  static createInstance(): UserInvite {
    return new UserInvite();
  }
}

export class ClientAuthorization extends ViewPushChannelListener {
  constructor() {
    super("ClientAuthorizationChannelListener");
  }

  static createInstance(): UserInvite {
    return new ClientAuthorization();
  }
}

export class ExternalUser extends ViewPushChannelListener {
  constructor() {
    super("ExternalUserChannelListener");
  }

  static createInstance(): UserInvite {
    return new ExternalUser();
  }
}
